import { render, staticRenderFns } from "./ErrorRedirectPage.vue?vue&type=template&id=2371f63e&"
import script from "./ErrorRedirectPage.vue?vue&type=script&lang=js&"
export * from "./ErrorRedirectPage.vue?vue&type=script&lang=js&"
import style0 from "./ErrorRedirectPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ErrorRedirectPage.vue"
export default component.exports